import styled from 'styled-components';
import { IconButton } from '@material-ui/core';

export const DrawerHeaderStyled = styled.div`
  color: white !important;
  font-size: 16px;

  ${({ fixed }) =>
    fixed &&
    `
    position: fixed;
    z-index: 2;
  `}

  width: 100%;
  background: rgb(0, 75, 196);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px 8px 8px;

  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
  }

  .save-btn {
    width: 80px;
    background-color: #5eab00 !important;
    color: white !important;
    border: none !important;
    border-radius: 25px !important;
  }
`;

export const IconButtonStyled = styled(IconButton)`
  svg {
    fill: #fff;
  }
`;
